/**
 * Patient testimonials.
 *
 * This list is intentionally empty.
 *
 * It previously drew from `src/mockData.js`, where five invented patients
 * ("John Musenga, Nigeria, Cardiac Bypass", etc.) were paired with Unsplash
 * stock portraits and presented under the heading "Real experiences from
 * international patients". Publishing invented patient outcomes as real ones
 * is a straightforward advertising-standards problem in the markets this site
 * targets - the UK (ASA/CAP), Canada, Australia and the Gulf states all treat
 * fabricated health testimonials as misleading advertising, and India's own
 * ASCI code says the same.
 *
 * The Testimonials section renders nothing while this array is empty, so the
 * page degrades cleanly rather than showing an empty carousel.
 *
 * To publish real testimonials, add entries in this shape - and keep written
 * consent on file for each one, including consent to name the treatment:
 *
 *   {
 *     id: 1,
 *     name: "Full name, or first name + initial if the patient prefers",
 *     country: "Patient's home country",
 *     treatment: "Procedure received",
 *     rating: 5,
 *     comment: "The patient's own words, unedited beyond length.",
 *     image: "/testimonials/<file>.jpg",  // a real photo, or omit entirely
 *     consentOnFile: true,
 *   }
 */
export const testimonials = [];
